import React from 'react'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'

import { trackClickForSegmentAnalytics } from '@infura/packages.common/segmentAnalytics'
import { ActionLink } from '@infura/packages.ui/ActionLink'
import { Card } from '@infura/packages.ui/Card'
import { Heading } from '@infura/packages.ui/Heading'
import { Text } from '@infura/packages.ui/Text'

import RoundedIcon from 'components/RoundedIcon'

interface ArticleItemProps {
  title: string
  copy: string
  cta: string
  link: string
  icon: IconDefinition
  isLimitMaxWidth?: boolean
}

export const ArticleItem = ({ copy, cta, icon, isLimitMaxWidth = false, link, title }: ArticleItemProps) => {
  const maxWidth = isLimitMaxWidth ? 'max-w-[290px]' : ''
  return (
    <Card className={`border-border-muted flex h-full flex-col justify-between ${maxWidth}`} theme='alternative'>
      <div className='w-full'>
        <RoundedIcon icon={icon} />
        <Heading as='h4' className='mb-4 mt-4'>
          {title}
        </Heading>
        <Text className='mb-4'>{copy}</Text>
      </div>
      <div className='w-full'>
        <ActionLink
          href={link}
          hrefTarget='_blank'
          icon={faArrowRight}
          onClick={() =>
            trackClickForSegmentAnalytics({
              clickText: title,
              clickUrl: link,
              location: `New GS tile: '${title}' link`,
              type: 'Text'
            })
          }
        >
          {cta}
        </ActionLink>
      </div>
    </Card>
  )
}
